import React, { useState } from 'react';
import { Layout, message, Table, Tag, Popconfirm, Typography } from 'antd';
import styles from './portalManagment.module.scss'; 
import PageHeader from '../TopHeader/PageHeader';
import PortalManagementForm from './PortalManagmentForm';

const PortalManagement = () => {
  return (
      <Layout className={styles.homeLayout}>
      <PageHeader title="Portal Management" className="all-customer-topbar" />
      <div className={styles.container}>
        <PortalManagementForm />
      </div>
      <div className={styles.tableDiv}>
      </div>
    </Layout>
  );
};

export default PortalManagement;
